import { FC, useEffect, useRef, useState } from 'react';

import { getRandomAvatarS3Image } from '@/core/apis/s3-api';

export type UserOnBoardProps = {
  fullName: string;
  onNameChange?: (name: string) => void;
  setDisplayPic: (path: string) => any;
  isValid?: (status: boolean) => void;
};

export const UserOnBoardFields: FC<UserOnBoardProps> = ({
  fullName,
  onNameChange = (name) => {},
  isValid = (status) => {},
  setDisplayPic,
}) => {
  const [name, setName] = useState(fullName);
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    getAndAssignRandomPlaceHolderImage();
    isValid(name.trim().length >= 3);
  }, []);

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, [inputRef]);

  const getAndAssignRandomPlaceHolderImage = async () => {
    const resp: any = await getRandomAvatarS3Image();

    if (resp?.data?.result) {
      setDisplayPic(resp?.data?.result?.imageUrl);
    }
  };

  return (
    <>
      <div>
        <label htmlFor="email" className="block text-sm font-medium text-gray-700 dark:text-gray-300">
          Name
        </label>
        <div className="mt-1">
          <input
            ref={inputRef}
            value={name}
            id="name"
            name="name"
            type="text"
            autoComplete="given-name"
            placeholder="Your name..."
            required
            className="block w-full appearance-none rounded-md border border-gray-300 dark:border-gray-700 px-3 py-2 text-gray-900 placeholder-gray-400 dark:placeholder-gray-500 shadow-sm sm:text-sm"
            onChange={(event) => {
              setName(event.target.value);
              onNameChange(event.target.value.trim());
              isValid(event.target.value.trim().length >= 3);
            }}
          />
        </div>
        {name?.length < 3 && (
          <div className="text-gray-400 dark:text-gray-500">Minimum 3 characters are required</div>
        )}
      </div>
    </>
  );
};
